import config from 'cityads-v3/config';
import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  TRUST_LEVELS,
  TRUST_LEVELS_SUCCESS,
  TRUST_LEVELS_FAIL,
} from "../actions/trustLevels";

const debugData = {
  "trustLevel":[]
};

const initialState = {
  trustLevels: [],
  trustLevelsById: {},
  isLoading: false,
  isLoaded: false,
};

export default function trustLevels(state = initialState, action = {}) {
  switch (action.type) {
    case TRUST_LEVELS:
      return {
        ...state,
        isLoading: true,
      }

    case TRUST_LEVELS_SUCCESS:
      const trustLevels = action.response.trustLevel.map(item => ({
        ...item,
        id: +item.id
      }))
      return {
        ...state,
        trustLevels: mapIds(trustLevels),
        trustLevelsById: {
          ...state.trustLevelsById,
          ...mapObjectize(trustLevels),
        },
        isLoading: false,
        isLoaded: true,
      }

    case TRUST_LEVELS_FAIL:
      return {
        ...state,
        trustLevels: mapIds(config.DEBUG ? debugData.trustLevel : []),
        trustLevelsById: {
          ...state.trustLevelsById,
          ...mapObjectize(config.DEBUG ? debugData.trustLevel : []),
        },
        isLoading: false,
        isLoaded: false,
      }

    default:
      return state;
  }
}
